import { Collapse } from 'antd'
import cx from 'classnames'
import PropTypes from 'prop-types'

import classNames from './styles.module.scss'


const { Panel } = Collapse

PanelComponent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  isActive: PropTypes.bool,
  isClassless: PropTypes.bool,
}

PanelComponent.defaultProps = {
  className: undefined,
  isOpen: false,
  isActive: false,
  isClassless: false,
}

export default function PanelComponent({
  children,
  className,
  isOpen,
  isActive,
  isClassless,
  ...props
}) {
  return (
    <Panel
      className={cx(!isClassless && classNames.panel, className)}
      isActive={isOpen || isActive}
      {...props}
    >
      <div className={classNames.content}>
        {children}
      </div>
    </Panel>
  )
}
